export default {
      id: "ar-art-usage",
      viewBox: "0 0 70 60",
      url: "../dist/images/" + "sprite.svg#ar-art-usage",
      toString: function () {
        return this.url;
      }
    }